// components/Snackbar/SnackbarManager.jsx
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Snackbar from '../UI/Snackbar';
import { closeSnackbar } from '../../redux/Snackbar/SnackbarActions';

const mapState = (state) => ({
  currentSnackbar: state.snackbar
});

class SnackbarManager extends Component {
  render() {
    const { currentSnackbar } = this.props;

    if (currentSnackbar) {
      return (
        <Snackbar
          title={currentSnackbar.title}
          message={currentSnackbar.message}
          type={currentSnackbar.type}
          duration={currentSnackbar.duration}
          onClose={this.props.closeSnackbar}
          position={currentSnackbar.position}
          onCompleted={currentSnackbar.onCompleted}
        />
      );
    }
    return null;
  }
}

const mapDispatch = (dispatch) => ({
  closeSnackbar: () => dispatch(closeSnackbar())
});

export default connect(mapState, mapDispatch)(SnackbarManager);